import { useMemo, useState } from "react"
import { observer } from "mobx-react-lite"

import { DialogSearch } from "@/domains/common/components/dialogues/dialog-search"
import { TokenStore } from "@/domains/tokens"
import { filterAndSortTokens, filterTokensBySearch } from "@/domains/tokens/utils/filter-tokens"

import { TokenStoreDialog } from "../token-dialog"
import { TokenList } from "../token-list"
import { TokenDialogTokenListHeader } from "./token-list-header"
import { TokenDialogVerifiedToggle } from "./verified-toggle"

export const SimpleTokenDialog: React.FC<{
  isOpen: boolean
  tokens: Array<TokenStore>
  onClose: () => void
  onTokenSelect: (token: TokenStore | null) => void
}> = observer(({ isOpen, tokens, onClose, onTokenSelect }) => {
  const [onlyVerifiedTokens, setOnlyVerifiedTokens] = useState(true)
  const [search, setSearch] = useState("")

  // Compute filtered tokens directly in render - allows observer to track token property changes
  const filteredTokens = filterAndSortTokens(tokens, onlyVerifiedTokens)

  // Apply search filter
  const searchTokens = useMemo(() => {
    return filterTokensBySearch(filteredTokens, search)
  }, [filteredTokens, search])

  return (
    <TokenStoreDialog isOpen={isOpen} onClose={onClose} title="Select Token">
      <DialogSearch value={search} onChange={setSearch} placeholder="Search by name, symbol, or address..." />
      <TokenDialogTokenListHeader
        tokenCount={searchTokens.length}
        controls={<TokenDialogVerifiedToggle checked={onlyVerifiedTokens} onCheckedChange={setOnlyVerifiedTokens} />}
      />
      <TokenList
        showTitle={false}
        tokens={searchTokens}
        onTokenSelect={onTokenSelect}
        onClose={onClose}
        maxHeight={368}
      />
    </TokenStoreDialog>
  )
})
